// A profile is considered "online" when its `last_seen_at` was updated within
// this window. The backend refreshes `last_seen_at` at most once per minute, so
// the threshold is kept comfortably above that to avoid active users flickering
// offline between heartbeats.
export const ONLINE_THRESHOLD_MS = 2 * 60 * 1000

/**
 * Whether a profile counts as online given its last-seen timestamp.
 *
 * @param {string|number|Date|null|undefined} lastSeenAt - ISO string / Date / epoch from the API
 * @param {number} [now] - current time in ms (injectable for reactivity/testing)
 * @returns {boolean}
 */
export function isOnline(lastSeenAt, now = Date.now()) {
    if (!lastSeenAt) {
        return false
    }

    const lastSeen = new Date(lastSeenAt).getTime()
    if (Number.isNaN(lastSeen)) {
        return false
    }

    return now - lastSeen < ONLINE_THRESHOLD_MS
}
